// ToggleGroup.tsx
import { Typography, ToggleButton, ToggleButtonGroup, useMediaQuery, useTheme } from '@mui/material';
import ToggleTick from './ToggleTick';

interface ToggleGroupProps {
    value: any;
    options: { value: string, label: string }[];
    onChange: (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => void;
    isToggleRestricted?: boolean;
}

const ToggleGroup: React.FC<ToggleGroupProps> = ({ value, options, onChange, isToggleRestricted }) => {
    const theme = useTheme();

    return (
        <ToggleButtonGroup
            exclusive
            value={value}
            onChange={onChange}
            sx={{ display: 'flex', flexDirection: 'row', flex: 1 }}
            disabled={isToggleRestricted}
        >
            {options.map((option) => (
                <ToggleButton key={option.value} value={option.value} sx={{ border: 'none', padding: '0.5rem' }}>
                    <ToggleTick isTrigger={value === option.value} />
                    <Typography variant='body2' noWrap>{option.label}</Typography>
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};

export default ToggleGroup;